export const QuestionTitle: React.FC<{ title: string }> = ({ title }) => {
  return <div className="lander__quiz__title">{title}</div>;
};
